import React from "react";

import Swiper from "../../../components/Swiper";
import AccommodationUnitSelector from "../../../components/Accommodations/AccommodationUnitSelector";


const ApartmentSwiper = ({accommodationUnitSelector, accommodations, children}) => {
    return <Swiper onNext={accommodationUnitSelector.selectNext}
                   onPrev={accommodationUnitSelector.selectPrev}
                   hasPrev={accommodations.isLoading ? false : accommodations.accommodationUnits.length > 1}
                   hasNext={accommodations.isLoading ? false : accommodations.accommodationUnits.length > 1}
                   headerEl={<AccommodationUnitSelector accommodationUnits={accommodations.accommodationUnits}
                                                        value={accommodationUnitSelector.selectedAccommodationUnit}
                                                        onChange={accommodationUnitSelector.handleChange}
                                                        isLoading={accommodations.isLoading}
                                                        align="center"/>}>
        {children}
    </Swiper>
}

export default ApartmentSwiper;